import { useCustomQuery } from "@/hooks/useCustomQuery"
import DetailAvatar from "@/components/Avatar/DetailAvatar"
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  IconButton,
  Divider,
} from "@mui/material"
import { useParams, Link } from "react-router-dom"
import { useState, useEffect } from "react"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import LetterAvatar from "@/components/Avatar/LetterAvatar"
import { DetailTable } from "@/components/Tables/DetailTable"
import { columns } from "@/pages/products/Columns"

const TagDetails = () => {
  const { id } = useParams()

  const {
    data: response,
    isLoading,
    isError,
    error,
  } = useCustomQuery(["tag-detail", id], `tags/${id}`)

  if (isLoading) {
    return <div>Loading...</div>
  }

  const tag = response?.data

  return (
    <div>
      <div className="breadcrumb-card">
        <h5>Tag Details</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/pos/dashboard">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>
            <Link to="/pos/tags">Tags</Link>
          </li>
          <li>{tag.name}</li>
        </ul>
      </div>
      {tag ? (
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-4 xxl:tw-grid-cols-5 tw-gap-6">
          <div className="card bg-white border-0 px-4 rounded-3 mb-4 lg:col-span-3 xxl:col-span-4">
            <p className="my-5 text-base font-semibold text-black">Products</p>

            <CrudProvider>
              <ProductLst tag={tag} isLoading={isLoading} />
            </CrudProvider>
          </div>
          <div className="card bg-white border-0 ps-5 rounded-3 mb-4">
            <div className="card-body p-4">
              <div className="flex align-items-center mb-3 mb-lg-4">
                <div className="flex align-items-center">
                  <DetailAvatar name={tag.name} />
                </div>
              </div>

              <div className="mb-3">
                <p>Created By:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  <LetterAvatar
                    name={tag.createdBy.name}
                    subtitle={tag.createdBy.email}
                  />
                </span>
              </div>

              <div className="mb-3">
                <p>Updated By:</p>
                <span className="d-block fw-medium text-secondary mt-1">
                  <LetterAvatar
                    name={tag.updatedBy.name}
                    subtitle={tag.updatedBy.email}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>No Supplier data found.</div>
      )}
    </div>
  )
}
function ProductLst({ tag, isLoading }) {
  return (
    <>
      <DetailTable
        columns={columns}
        data={tag.products}
        isLoading={isLoading}
      />
    </>
  )
}

export default TagDetails
